import { Form, Input } from 'antd';
import { useTranslation } from 'react-i18next';
import { CopyButton } from 'src/components/Form/CopyButton';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/** Content fields for car details */
export var TaskFormContentCarDetails = function TaskFormContentCarDetails(_ref) {
  var isReadonly = _ref.isReadonly;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsxs(Container, {
    children: [/*#__PURE__*/_jsx(CopyButton, {
      field: ['content', 'brand'],
      children: /*#__PURE__*/_jsx(Form.Item, {
        name: ['content', 'brand'],
        label: t('form.carDetails.brand.label'),
        children: /*#__PURE__*/_jsx(Input, {
          bordered: !isReadonly,
          readOnly: isReadonly,
          placeholder: isReadonly ? t('form.carDetails.brand.empty') : t('form.carDetails.brand.placeholder')
        })
      })
    }), /*#__PURE__*/_jsx(CopyButton, {
      field: ['content', 'model'],
      children: /*#__PURE__*/_jsx(Form.Item, {
        name: ['content', 'model'],
        label: t('form.carDetails.model.label'),
        children: /*#__PURE__*/_jsx(Input, {
          bordered: !isReadonly,
          readOnly: isReadonly,
          placeholder: isReadonly ? t('form.carDetails.model.empty') : t('form.carDetails.model.placeholder')
        })
      })
    }), /*#__PURE__*/_jsx(CopyButton, {
      field: ['content', 'commercialName'],
      children: /*#__PURE__*/_jsx(Form.Item, {
        name: ['content', 'commercialName'],
        label: t('form.carDetails.commercialName.label'),
        children: /*#__PURE__*/_jsx(Input, {
          bordered: !isReadonly,
          readOnly: isReadonly,
          placeholder: isReadonly ? t('form.carDetails.commercialName.empty') : t('form.carDetails.commercialName.placeholder')
        })
      })
    }), /*#__PURE__*/_jsx(CopyButton, {
      field: ['content', 'variant'],
      children: /*#__PURE__*/_jsx(Form.Item, {
        name: ['content', 'variant'],
        label: t('form.carDetails.variant.label'),
        children: /*#__PURE__*/_jsx(Input, {
          bordered: !isReadonly,
          readOnly: isReadonly,
          placeholder: isReadonly ? t('form.carDetails.variant.empty') : t('form.carDetails.variant.placeholder')
        })
      })
    }), /*#__PURE__*/_jsx(CopyButton, {
      field: ['content', 'plateNumber'],
      children: /*#__PURE__*/_jsx(Form.Item, {
        name: ['content', 'plateNumber'],
        label: t('form.carDetails.plateNumber.label'),
        children: /*#__PURE__*/_jsx(Input, {
          bordered: !isReadonly,
          readOnly: isReadonly,
          placeholder: isReadonly ? t('form.carDetails.plateNumber.empty') : t('form.carDetails.plateNumber.placeholder')
        })
      })
    }), /*#__PURE__*/_jsx(CopyButton, {
      field: ['content', 'chassisNumber'],
      children: /*#__PURE__*/_jsx(Form.Item, {
        name: ['content', 'chassisNumber'],
        label: t('form.carDetails.chassisNumber.label'),
        children: /*#__PURE__*/_jsx(Input, {
          bordered: !isReadonly,
          readOnly: isReadonly,
          placeholder: isReadonly ? t('form.carDetails.chassisNumber.empty') : t('form.carDetails.chassisNumber.placeholder')
        })
      })
    })]
  });
}; // Styles

var Container = styled.div.withConfig({
  displayName: "CarDetails__Container",
  componentId: "sc-2oe80o-0"
})([""]);